import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { CommonContext } from '../common/context/commonContext'
import { ScrollPanel } from 'primereact/scrollpanel'
import { useNavigate } from 'react-router-dom'
import { isEmpty, size } from 'lodash'
import { AbrogationLocation, AbrogationLocationsSearch, LocationData, LocationsSearch } from '../../types/inventory'
import { useMountEffect } from 'primereact/hooks'
import { InputText } from 'primereact/inputtext'
import { includeComma } from '../../utils/inputText'
import { Checkbox } from 'primereact/checkbox'
import { IncomingSearch } from '../../types/inbound'
import { getContentSize } from '../../utils/screenUtils'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const AbrogationExpectedLocation = () => {
    const navigate = useNavigate()
    const { $http, $toast } = useContext(CommonContext)
    const { t } = useTranslation()
    const scrollRef = useRef<HTMLDivElement>(null)
    const [total, setTotal] = useState<number>(0)
    const totalRef = useRef<number>(0)
    const [lctSeq, setLctSeq] = useState<string>()
    const [locations, setLocations] = useState<AbrogationLocation[]>([])
    const locationsRef = useRef<AbrogationLocation[]>([])
    const paramsRef = useRef<AbrogationLocationsSearch>({
        page: 1,
        pageSize: 20,
        sort: '',
        sortOrder: undefined,
        sortField: '',
    })

    useMountEffect(() => {
        findAbrgList(paramsRef.current)
    })

    useMountEffect(() => {
        if (scrollRef.current) {
            const scroll = scrollRef.current
            scroll.addEventListener('scrollend', pagingSearch)
        }
    })

    const findAbrgList = useCallback(
        async (params: AbrogationLocationsSearch) => {
            const { total, list } = await $http().post('/inventory/find-abrg-expect', params)
            console.log(list)

            if (total < 1) {
                $toast({
                    title: t(tokens.common.disposal_schedule_inquiry),
                    text: t(tokens.inventory.not_exists_diposal_schedule_stock),
                    icon: 'success',
                })
                paramsRef.current = {
                    ...paramsRef.current,
                    page: 1,
                }
                setTotal(total)
                totalRef.current = total
                setLocations([])
                locationsRef.current = []
                return
            }

            if (params.page === 1) {
                setTotal(total)
                totalRef.current = total
                setLocations(list)
                locationsRef.current = list
            } else {
                locationsRef.current = [...locationsRef.current, ...list]
                setLocations(locationsRef.current)
            }
        },
        [$http],
    )

    const pagingSearch = async () => {
        if (scrollRef.current) {
            if (paramsRef.current.page && paramsRef.current.pageSize) {
                const isNext = totalRef.current > paramsRef.current.page * paramsRef.current.pageSize
                // && scroll.offsetHeight + scroll.scrollTop >= scroll.scrollHeight - 0.5
                if (isNext) {
                    paramsRef.current = {
                        ...paramsRef.current,
                        page: paramsRef.current.page + 1,
                    }

                    console.log('pagingSearch', JSON.stringify(paramsRef.current))
                    const { list } = await $http().post('/inventory/find-abrg-expect', paramsRef.current)
                    locationsRef.current = [...locationsRef.current, ...list]
                    setLocations(locationsRef.current)
                }
            }
        }
    }

    const onClickDetail = (lctSeq: string) => {
        setLctSeq(lctSeq)
        navigate(`/location-detail`, { state: { lctSeq: lctSeq } })
    }

    return (
        <>
            <div className="grid pda-search">
                <div className="col-12 flex pt-1">
                    <span className="font-bold text-lg rdms-text-deepblue">
                        {t(tokens.common.total_sum)} {includeComma(total, '-')} {t(tokens.common.item_count)}
                    </span>
                </div>
            </div>
            <div className="grid mt-0 pt-0 pl-1">
                <div ref={scrollRef} className="overflow-y-scroll w-full" style={{ height: getContentSize() }}>
                    {locations &&
                        locations.map((item) => (
                            <div className="mt-1 border-1 border-round-2xl bg-white" key={item.lctSeq} onClick={() => onClickDetail(item.lctSeq)}>
                                <div className="col-12 justify-content-between flex">
                                    <div className="font-bold rdms-text-deepblue">{t(tokens.inventory.location)}</div>
                                </div>
                                <div className="col-12 justify-content-between flex font-bold">
                                    <div className="font-bold">
                                        {`${item.sectorNm + '' + item.bayId?.substring(1)}-${item.rackRowId?.padStart(
                                            2,
                                            '0',
                                        )}-${item.rackColId?.padStart(2, '0')}`}{' '}
                                        : {item.lctTypNm}
                                    </div>
                                    <div className="font-bold rdms-text-deepblue">{t(tokens.inventory.disposal_schedule)}</div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </>
    )
}

export default AbrogationExpectedLocation
